import { render, staticRenderFns } from "./AllianceProfile.vue?vue&type=template&id=5109d3c5&scoped=true&"
import script from "./AllianceProfile.vue?vue&type=script&lang=js&"
export * from "./AllianceProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5109d3c5",
  null
  
)

export default component.exports